<script>
import MethodForm from "@/driver/pages/masters/recycle_disposal_patterns/methods/_Form.vue";

export default {
  name: "MasterMethodEdit",
  components: {
    MethodForm,
  },
  props: {},
  data () {
    return {
      breadcrumbs: [
        { text: '再資源化等パターン', disabled: false, to: '/driver/masters/recycle_disposal_patterns', exact: true },
        { text: '処分場処理方法編集', disabled: true, to: '' },
      ],
      targetId: null,
    }
  },
  watch: {},
  computed: {},
  created() {
    this.targetId = parseInt(this.$route.params.id);
  },
  methods: {
  }

}
</script>

<template>
  <v-container fluid>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />

    <method-form :target-id="targetId" />
  </v-container>
</template>

<style scoped lang="scss">

</style>
